import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

import {
  AccountModule,
  ApiKeyModule,
  AttachmentModule,
  ChannelModule,
  ExpenseModule,
  RateModule,
  RentalModule,
  TagModule,
  UserModule,
  WizardStateModule,
} from '@tokeet/tv3-platform'

import { InquiryModule } from '@tv3/store/inquiry/inquiry.module'
import { InvoiceModule } from '@tv3/store/invoice/invoice.module'
import { PreferenceModule } from '@tv3/store/preferences/preferences.module'
import { ForwardModule } from '@tv3/store/forward/forward.module'
import { TaskModule } from '@tv3/store/task/task.module'
import { CalendarModule } from '@tv3/store/calendar/calendar.module'
import { GuestModule } from '@tv3/store/guest/guest.module'
import { ItineraryModule } from '@tv3/store/itinerary/itinerary.module'
import { NoteModule } from '@tv3/store/note/note.module'
import { MessageModule } from '@tv3/store/message/message.module'
import { PlanModule } from '@tv3/store/plan/plan.module'
import { DataFeedModule } from '@tv3/store/datafeed/datafeed.module'
import { ConnectionModule } from '@tv3/store/connection/connection.module'
import { UserPreferenceModule } from '@tv3/store/user-preferences/user-preferences.module'
import { WebsiteModule } from '@tv3/store/website/website.module'
import { PaymentRuleModule } from '@tv3/store/payment-rule/payment-rule.module'
import { SharedContentModule } from '@tv3/store/shared-content/shared-content.module'
import { NotificationModule } from '@tv3/store/notification/notification.module'
import { CustomCodeModule } from '@tv3/store/custom-codes/custom-code.module'
import { WebsiteImageModule } from '@tv3/store/website-image/website-image.module'
import { OverlayModule } from '@tv3/store/overlay/overlay.module'
import { ContractModule } from '@tv3/store/contract/contract.module'
import { StealthModule } from './stealth/stealth.module'
import { ChannelPropertySettingModule } from '@tv3/store/channel-property-setting/channel-property-setting.module'
import { BillingModule, CardModule } from '@tokeet-frontend/billing'
import { TemplatesLibraryModule } from '@tokeet-frontend/templates'
import {
  InvoiceLibraryModule,
  InvoiceRuleLibraryModule,
  InvoiceTemplateStoreLibraryModule,
} from '@tokeet-frontend/invoices'
import { GatewayLogModule, GatewaysModule, GatewayTypeModule } from '@tokeet-frontend/gateways'

@NgModule({
  imports: [
    CommonModule,
    BillingModule,
    CardModule,
    AccountModule,
    ApiKeyModule,
    ExpenseModule,
    InquiryModule,
    RentalModule,
    ChannelModule,
    InvoiceModule,
    OverlayModule,
    ItineraryModule,
    PreferenceModule,
    ForwardModule,
    TaskModule,
    UserModule,
    UserPreferenceModule,
    CalendarModule,
    AttachmentModule,
    GuestModule,
    CustomCodeModule,
    NoteModule,
    ContractModule,
    MessageModule,
    TagModule,
    PlanModule,
    DataFeedModule,
    ConnectionModule,
    WebsiteModule,
    WebsiteImageModule,
    RateModule,
    ConnectionModule,
    GatewaysModule,
    GatewayTypeModule,
    GatewayLogModule,
    PaymentRuleModule,
    SharedContentModule,
    NotificationModule,
    WizardStateModule,
    StealthModule,
    ChannelPropertySettingModule,
    InvoiceLibraryModule,
    InvoiceRuleLibraryModule,
    InvoiceTemplateStoreLibraryModule,
    TemplatesLibraryModule,
  ],
  declarations: [],
})
export class RootStoreModule {}
